import React from "react";
import {
  Box, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Chip,
  CircularProgress, Tooltip, IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const COLUMNS = ["#", "Name", "Sub Title", "Order", "Module", "Active", "Show in App", "Created At", "Actions"];

const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export default function SubModuleTable({ data, loading, onEdit, moduleMap }) {
  return (
    <Box
      sx={{
        background: "#ffffff",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
        overflow: "hidden",
      }}
    >
      <Box sx={{ background: "#04343a", px: 3, py: 1.5 }}>
        <Typography sx={{ color: "#ffffff", fontWeight: 600, fontSize: "0.9rem" }}>
          All Sub Modules ({data.length})
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 8 }}>
          <CircularProgress sx={{ color: "#016551" }} />
        </Box>
      ) : (
        <TableContainer component={Paper} elevation={0}>
          <Table>
            <TableHead>
              <TableRow sx={{ background: "#f8fafc" }}>
                {COLUMNS.map((h) => (
                  <TableCell
                    key={h}
                    sx={{ fontWeight: 700, fontSize: "0.8rem", color: "#374151", borderBottom: "2px solid #e2e8f0" }}
                  >
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 6, color: "#94a3b8" }}>
                    No sub modules found
                  </TableCell>
                </TableRow>
              ) : (
                data.map((row, idx) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:hover": { background: "#f8fafc" }, "&:last-child td": { border: 0 } }}
                  >
                    <TableCell sx={{ color: "#64748b", fontSize: "0.85rem" }}>{idx + 1}</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem", color: "#1e293b" }}>
                      {row.name}
                    </TableCell>
                    <TableCell sx={{ color: "#374151", fontSize: "0.875rem" }}>
                      {row.sub_title || "—"}
                    </TableCell>
                    <TableCell sx={{ color: "#374151", fontSize: "0.875rem" }}>{row.order}</TableCell>
                    <TableCell sx={{ fontSize: "0.875rem" }}>
                      <Chip
                        label={moduleMap[row.home_page_module] || `Module ${row.home_page_module}`}
                        size="small"
                        sx={{
                          background: "rgba(4,52,58,0.08)",
                          color: "#04343a",
                          fontWeight: 600,
                          fontSize: "0.75rem",
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={row.is_active ? "Active" : "Inactive"}
                        size="small"
                        sx={{
                          background: row.is_active ? "rgba(1,101,81,0.1)" : "rgba(239,68,68,0.1)",
                          color: row.is_active ? "#016551" : "#dc2626",
                          fontWeight: 600,
                          fontSize: "0.75rem",
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={row.show_in_app ? "Yes" : "No"}
                        size="small"
                        sx={{
                          background: row.show_in_app ? "rgba(37,99,235,0.1)" : "rgba(100,116,139,0.1)",
                          color: row.show_in_app ? "#2563eb" : "#64748b",
                          fontWeight: 600,
                          fontSize: "0.75rem",
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "0.8rem" }}>
                      {formatDate(row.created_at)}
                    </TableCell>
                    <TableCell>
                      <Tooltip title="Edit" placement="top">
                        <IconButton
                          size="small"
                          onClick={() => onEdit(row)}
                          sx={{ color: "#016551", "&:hover": { background: "rgba(1,101,81,0.1)" } }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
